export enum AvcActions {
    GET_ENTRY_STATE = 'getEntryState',
    SET_LOADING = 'setAvcLoading',
    SET_ERROR = 'setAvcError',
    SET_INPUT = 'setInput',
    SET_FORM = 'setForm',
    SET_ADDRESSES = 'setAddresses',
    CHECK_ADDRESS = 'checkAddress',
    RESET_FORM = 'resetForm',
    SET_ACCESS_SUPPLIIER = 'accessSupplier',
    SET_AVAILABILITY_INDICATOR = 'availabilityIndicator',
    SET_ROLLOUT_STATUS = 'rolloutStatus',
    SET_ROLLOUT_END_MONTH = 'rolloutEndMonth'
}

export enum Inputs {
    CITY = 'city',
    STREET = 'street',
    NUMBER = 'number',
}

export const enum FormInputType {
    CONTROL = 'control',
    ELEMENT_BLOCK = 'element_block'
}

export enum ErrorMessage {
    NON_UNIQUE_ADDRESS = 'Not a unique address',
    ADDRESS_NOT_FOUND = 'Address not found',
    TARIFF_ID_NOT_DEFINED = 'Tariff id not defined',
    EMPTY_RESPONSE = 'Empty response',
}
